import { html } from 'lit';
import { FsHeading } from '@cof/fs-typography-wc/fs-heading';
import typographyStyles from '@cof/fs-typography-core/lib/typography.lit.js';
import { style } from './refi-heading.style.js';

export class RefiHeadingComponent extends FsHeading {
  static styles = [style, ...FsHeading.styles, typographyStyles];

  constructor() {
    super();
    this.size = '';
    this.isIconic = false;
  }

  static properties = {
    size: { type: String, attribute: 'size' },
    isIconic: { type: Boolean, attribute: 'is-iconic' },
  };

  render() {
    return html`
      <fs-heading
        class="header ${this.size === 'large'
          ? 'fs-text-size--medium-3 fs-text-weight--light'
          : ''}
            ${this.isIconic ? 'fs-text-size--medium-3' : ''}"
        level="1"
        size="medium"
        variant="primary"
      >
        <slot></slot>
      </fs-heading>
      <fs-heading class="sub-header" level="2" size="small" variant="primary">
        <slot name="sub-header"></slot>
      </fs-heading>
    `;
  }
}

customElements.define('refi-heading', RefiHeadingComponent);
